import { Injectable, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { Storage } from "@ionic/storage";
import { STORAGE } from "../constant/storages";
import { Datum } from "../pages/tax-invoice/tpye";
import { _getStorage, _setStorage } from "../utils/local-storage";  
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class AppService {
  active: EventEmitter<number> = new EventEmitter();
  activereplace: EventEmitter<number> = new EventEmitter();
  cardEvent: EventEmitter<any> = new EventEmitter();
  nocredit: EventEmitter<number> = new EventEmitter();

  user_id: string = "";
  user_bu: string = "";
  user_loc: string = "";
  user_role: string = "";

  search_data: Datum[];

  versionString: string;
  versionNumber: string;
  versionAPI : string = '';
  versionBE : string = '';

  province: any = [];
  district: any = [];
  sub_district: any = [];
  zipcode: any = [];
  address_thai: any = [];
  Country: any = [];
  setnoTaxName: any;
  // version_string: any = 'alpha Version 0.0.2';

  constructor(public storage: Storage, private router: Router ,private http: HttpClient) {
    this.setUser();
    this.loadAPIVersion();
    this.loadSystemVersion();
    console.log("address_thai", this.address_thai);
  }

   async loadAPIVersion() {
    try {
      const apiUrl = `${environment.getAPIVersionUrl}`;
      const headers = {
        'api-key':  `${environment.apikey}`
      };
      const res: any = await this.http.get(apiUrl, { headers }).toPromise();
      this.versionAPI = res?.version || ""; 
      _setStorage(
              STORAGE.VERSION_API,
              this.versionAPI
            ); 
    } catch (err) {
      console.error("[AppService] Failed to load backend version:", err);
    }
  }

  async loadSystemVersion() {
    try {
      const apiUrl = `${environment.getSystemVersionUrl}`;
      const headers = {
        'api-key':  `${environment.apikey}`
      };
      const res: any = await this.http.get(apiUrl, { headers }).toPromise();
      this.versionBE = res?.version || ""; 
      _setStorage(
              STORAGE.VERSION_BE,
              this.versionBE
            ); 
    } catch (err) {
      console.error("[AppService] Failed to load backend version:", err);
    }
  }

  setCardEvent(value: any) {
    this.cardEvent.emit(value);
  }
  setActiveNoCredit(n: number) {
    this.nocredit.emit(n);
  }

  setUser() {
    this.user_id = window.localStorage.userID;
    this.user_bu = window.localStorage.userBu;
    this.user_loc = window.localStorage.userLoc;
    this.user_role = window.localStorage.userRole;
  }

  setActive(e: number) {
    console.log("[setActive] input : ", e);
    this.active.emit(e);
  }

  setreplace(e: number) {
    this.activereplace.emit(e);
  }

  setSearchData(data: Datum[]) {
    console.log("set search >>>", data);
    this.search_data = data;
  }

  resetdata() {
    this.search_data = [];
  }
  checkIdentityCardNumber(id: string) {
    console.log("[checkIdentityCardNumber] value is : ", id);
    let total = 0;
    let iPID;
    let chk;
    let Validchk;
    iPID = id.replace(/-/g, "");
    Validchk = iPID.substr(12, 1);
    let j = 0;
    let pidcut;
    for (let n = 0; n < 12; n++) {
      pidcut = parseInt(id.substr(j, 1));
      total = total + pidcut * (13 - n);
      j++;
    }

    chk = 11 - (total % 11);

    if (chk == 10) {
      chk = 0;
    } else if (chk == 11) {
      chk = 1;
    }
    if (chk == Validchk) {
      return true;
    } else {
      return false;
    }
  }

  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 10) {
      // less than 10 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 10 total pages so calculate start and end pages
      if (currentPage <= 6) {
        startPage = 1;
        endPage = 10;
      } else if (currentPage + 4 >= totalPages) {
        startPage = totalPages - 5;
        endPage = totalPages;
      } else {
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array(endPage + 1 - startPage).keys()).map(
      (i) => startPage + i
    );

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }

  mappingConfigRoleManagement(appPages: any) {
    console.log("appPages====: ", appPages);
    let modules = _getStorage(STORAGE.modules);
    console.log("[mappingConfigRoleManagement] modules : ", modules);

    for (let app of appPages) {
      let title = app.title.replaceAll(" ", "").toUpperCase();
      switch (title) {
        case "CUSTOMERDATA":
          app.isActive = modules.ETAXSUBCONFIG?.SUB_CUSTOMER || false;
          // app.isActive = false;
          break;
        case "SELLERDATA":
          app.isActive = modules.ETAXSUBCONFIG?.SUB_SELLER || false;
          break;
        case "ROLEMANAGEMENT":
          app.isActive = modules.ETAXSUBCONFIG?.SUB_ROLESETUP || false;
          // app.isActive = false;
          break;
        case "CONFIGURATION":
          app.isActive = modules.ETAXSUBCONFIG?.SUB_CONFIGSETUP || false;
          break;
      }
    }
    return appPages;
  }

  mappingRoleManagement(appPages: any) {
    console.log("appPages====: ", appPages);
    let modules = _getStorage(STORAGE.modules);
    console.log("[mappingRoleManagement] modules : ", modules);

    for (let app of appPages) {
      let title = app.title.replaceAll(" ", "").toUpperCase();

      console.log("title=======: ",title)

      switch (title) {
        case "TAXINVOICE":
          app.isActive = modules.ETAXFULLTAX;
          break;
        case "NOTAXID":
          app.isActive = modules.ETAXFULLTAXNOTAXID;
          break;
        case "REPLACE":
          app.isActive = modules.ETAXREPLACE;
          break;
        case "CREDITNOTE":
          app.isActive = modules.ETAXCREDITNOTE;
          break;
        case "REPORT":
          app.isActive = modules.ETAXREPORT;
          break;
        case "RESEND/PRINT":
          app.isActive = modules.ETAXRESEND;
          break;
        case "INQUIRYDATA":
          app.isActive = modules.ETAXINQUIRY;
          break;
        case "CONFIG":
          app.isActive = modules.ETAXCONFIGURATION;
          break;
      }
    }

    return appPages;
  }

  dropUser() {
    let data = {
      user: window.localStorage.userID,
      role: window.localStorage.userRole,
      userLoc: window.localStorage.userLoc,
    };
    return data;
  }
  // Active = 0;
  ActiveNotaxID() {
    let Active: Number;
    let res = _getStorage("ActiveNoTaxID");
    console.log("ActiveNoTaxID.....", res);
    Active = res;
  }

  setNameNotax(item: any) {
    console.log("set name notax...", item);
    if (item === "tax") {
      return "No Tax ID - Tax Invoice";
    } else if (item === "replace") {
      return "No Tax ID - Replace";
    } else if (item === "cn") {
      return "No Tax ID - CreditNote";
    } else if (item === "no") {
      return "No Tax ID";
    }
  }
  logout() {
    const get_keyCardID = _getStorage(STORAGE.DATA_KEY_CARDID);
    localStorage.clear();
    this.storage.clear();
    _setStorage(
      STORAGE.DATA_KEY_CARDID,
      get_keyCardID === null ? [] : get_keyCardID
    );
    setTimeout(() => {
      this.router.navigateByUrl("/login");
    }, 500);
  }
}
